import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';

export type AuthTypeValue = 'roblox-api-key' | 'roblox-oauth2' | 'roblox-legacy-cookie' | 'none';

export const getAuthenticationTypes = (
  operation: OpenAPI.OperationObject,
  document: OpenAPI.Document,
): AuthTypeValue[] => {
  const authTypes: Set<string> = new Set();

  const securityRequirements = operation.security || document.security || [];

  securityRequirements.forEach((requirement) => {
    const schemes = Object.keys(requirement);
    // Empty requirement object means the operation also supports no authentication
    if (schemes.length === 0) {
      authTypes.add('none');
      return;
    }

    schemes.forEach((securityScheme) => {
      // Check for specific Roblox authentication types
      if (
        securityScheme === 'roblox-legacy-cookie' ||
        securityScheme === 'roblox-api-key' ||
        securityScheme === 'roblox-oauth2'
      ) {
        authTypes.add(securityScheme);
      }
    });
  });

  // Return in a fixed order: API Key, OAuth2, Cookie, None
  const order: AuthTypeValue[] = [
    'roblox-api-key',
    'roblox-oauth2',
    'roblox-legacy-cookie',
    'none',
  ];
  return order.filter((type) => authTypes.has(type)) as AuthTypeValue[];
};
